import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={12}>
              <div className="text-sm-right d-none d-sm-block">
              © WeCrest Ltd {new Date().getFullYear()} all rights reserved
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
    /*
    Design & Develop by Themesbrand
    */
  )
}

export default Footer
